<template>
  <a-modal :visible="visible" :title="$t('messageDetails')" :closable="false" @cancel="setModalVisible('cancle')">
    <div class="detail-wrap" v-if="msgObj.messageReference" v-viewer="viewerOption">
      <div class="user-wrap">
        <div class="left-wrap">
          <div class="user-img">
            <img class="avatar-image" :src="imgDefaultAgent(msgObj)" />
          </div>
          <span>{{msgObj.messageReference.refSenderName || item.messageReference.refSenderId}}</span>
        </div>
        <div class="right-wrap">
          {{$t('messageSendTime')}}: {{msgObj.messageReference.refSendTime}}
        </div>
      </div>
      <div class="msg-wrap">
        <!-- 纯文本/富文本 [[ -->
        <div v-if="msgObj.messageReference.refContentType == 'text'"
          v-html="replaceFace(msgObj.messageReference.refContent)"></div>
        <!-- 纯文本/富文本 ]] -->
        <!-- 图片 [[ -->
        <img v-else-if="msgObj.messageReference.refContentType == 'image'" :src="msgObj.messageReference.refContent" />
        <!-- 图片 ]] -->
        <!-- 音频 [[ -->
        <div
          v-else-if="msgObj.messageReference.refContentType == 'voice' || msgObj.messageReference.refContentType == 'videoCall'">
          <audio :src="msgObj.messageReference.refContent" controls="controls"></audio>
        </div>
        <!-- 音频 ]] -->
        <!-- 视频 [[ -->
        <div v-else-if="msgObj.messageReference.refContentType == 'video'">
          <video preload="none" :src="msgObj.messageReference.refContent" class="content-video"
            controls="controls">{{$t('doseNotsupportVideo')}}</video>
        </div>
        <!-- 视频 ]] -->
        <!-- 文档 [[ -->
        <div v-else-if="msgObj.messageReference.refContentType == 'document'">
          <a :href="msgObj.messageReference.refContent" download target="__blank"
            style="text-decoration: underline;">{{$t('clickDownload')}} >
            {{msgObj.messageReference.refFileName}}</a>
        </div>
        <!-- 文档 ]] -->
        <!-- 其它 [[ -->
        <div v-else>

        </div>
        <!-- 其它 ]] -->
      </div>
    </div>
    <template slot="footer">
      <a-button type="default" @click="setModalVisible('cancle')">{{$t('CLOSE')}}</a-button>
    </template>
  </a-modal>
</template>

<script>
  import ajax from '@/ajax/axios-ajax.js'
  import apis from '@/apis/index.js'
  import FaceObjConfig from '@/assets/data/faceObjConfig'
  export default {
    components: {

    },
    data() {
      return {
        visible: false,
        msgObj: {},
        viewerOption: { // 图片预览插件配置
          navbar: false,
          rotatable: true,
          toolbar: true,
          title: false,
          button: true,
          className: 'customer-viewer-box',
          filter: (image) => { // 表情图片不放大
            return image.className !== 'face-image' && image.className !== 'avatar-image'
          },
          fullscreen: false
        },
        belong: null
      }
    },
    created() {

    },
    methods: {
      replaceFace: FaceObjConfig.replaceFace,
      imgDefaultAgent(msgObj) {
        if (this.belong === 'agent') {
          // if (msgObj.senderPicture) {
          //   return msgObj.senderPicture
          // } else {
            return  require('@/assets/img/icon-img/agent-avatar.png')
          // }
        } else if (this.belong === 'robot') {
          return require('@/assets/img/icon-img/robot-agent-icon.svg')
        } else {
          return require('@/assets/img/icon-img/visitor-avatar.png')
        }
      },
      setModalVisible(type, msgObj) {
        switch (type) {
          case 'open':
            this.msgObj = msgObj
            this.getReferenceMsgDetail().then(res=> {
              this.visible = true
            })
            break
          case 'cancle':
            this.visible = false
            break
        }
      },
      getReferenceMsgDetail() {
        let params = {
          beginTime: this.msgObj.sendTime,
          serviceId: this.msgObj.serviceId,
          messageId: this.msgObj.messageId,
          tenantId: this.msgObj.tenantId
        }
        return new Promise((resolve, reject) => {
          ajax.get(apis.chat.getReferenceMessageDetail, {params}).then((res) => {
            const { success, data, message } = res || {}
            if (success) {
              this.belong = data.belong
              resolve(data)
            } else {
              this.$message.error(message)
            }
          })
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .detail-wrap {
    .user-wrap {
      display: flex;
      line-height: 40px;
      margin-bottom: 20px;

      .left-wrap {
        flex: 1;
        justify-content: flex-start;

        .user-img {
          width: 40px;
          height: 40px;
          float: left;
          border-radius: 40px;
          overflow: hidden;

          img {
            float: left;
            width: 100%;
            height: 100%;
          }
        }

        span {
          float: left;
          margin-left: 8px;
        }
      }

      .right-wrap {
        flex: 1;
        justify-content: flex-end;
        color: #B5BECB;
        font-size: 12px;
        text-align: right;
      }
    }

    .msg-wrap {
      max-height: 200px;
      overflow-y: auto;
      margin-left: 48px;
      padding: 12px;
      font-size: 14px;
      box-shadow: 0px 1px 10px 1px rgba(194, 207, 229, 0.5);
      border-radius: 4px;

      /deep/ img {
        max-width: 100%;
      }
    }
  }

  .content-video {
    max-width: 200px;
    max-height: 200px;
  }
</style>